/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompteBancaireLightDto } from './CompteBancaireLightDto';
import {
    CompteBancaireLightDtoFromJSON,
    CompteBancaireLightDtoFromJSONTyped,
    CompteBancaireLightDtoToJSON,
    CompteBancaireLightDtoToJSONTyped,
} from './CompteBancaireLightDto';

/**
 * Co-assureur d'une garantie du tunnel.
 * @export
 * @interface CoAssureurDto
 */
export interface CoAssureurDto {
    /**
     * 
     * @type {string}
     * @memberof CoAssureurDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CoAssureurDto
     */
    personneMoraleId?: string;
    /**
     * 
     * @type {string}
     * @memberof CoAssureurDto
     */
    designation?: string | null;
    /**
     * Code sous-nature de la compagnie (MUT, REA…), null pour un assureur classique.
     * @type {string}
     * @memberof CoAssureurDto
     */
    sousNature?: string | null;
    /**
     * 
     * @type {CompteBancaireLightDto}
     * @memberof CoAssureurDto
     */
    compteBancaire?: CompteBancaireLightDto;
    /**
     * 
     * @type {boolean}
     * @memberof CoAssureurDto
     */
    aperition?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CoAssureurDto
     */
    tauxQP?: number;
}

/**
 * Check if a given object implements the CoAssureurDto interface.
 */
export function instanceOfCoAssureurDto(value: object): value is CoAssureurDto {
    return true;
}

export function CoAssureurDtoFromJSON(json: any): CoAssureurDto {
    return CoAssureurDtoFromJSONTyped(json, false);
}

export function CoAssureurDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoAssureurDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'personneMoraleId': json['personneMoraleId'] == null ? undefined : json['personneMoraleId'],
        'designation': json['designation'] == null ? undefined : json['designation'],
        'sousNature': json['sousNature'] == null ? undefined : json['sousNature'],
        'compteBancaire': json['compteBancaire'] == null ? undefined : CompteBancaireLightDtoFromJSON(json['compteBancaire']),
        'aperition': json['aperition'] == null ? undefined : json['aperition'],
        'tauxQP': json['tauxQP'] == null ? undefined : json['tauxQP'],
    };
}

export function CoAssureurDtoToJSON(json: any): CoAssureurDto {
    return CoAssureurDtoToJSONTyped(json, false);
}

export function CoAssureurDtoToJSONTyped(value?: CoAssureurDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'personneMoraleId': value['personneMoraleId'],
        'designation': value['designation'],
        'sousNature': value['sousNature'],
        'compteBancaire': CompteBancaireLightDtoToJSON(value['compteBancaire']),
        'aperition': value['aperition'],
        'tauxQP': value['tauxQP'],
    };
}

